import {checkWindowFunctionWithArgs} from '../Models/CommonItemsModel'; 
export enum TransactionStatus {
    Cancelled = -1,
    Pending = 0,
    Completed = 1
};
export enum EntityType {
    Payer = "P",
    ResponsibleParty = "R" 
};

export const RefundColumnDefinitions = 
{
    Column1: 4, 
    Column2: 5,
    Column3: 7,
    Column4: 25
};

export interface IRefundResponse {
    errorCode: number
    errorMessage: string 
};
export interface IRefundAddress {
    description: string,
    fullAddress: string
};
export interface IRefundContact {
    contactName: string,
    contactDescription: string,
    contactNumber: string
};
export interface IRefundRegisterDetail {
    transactionRegisterID: number,
    refundEntityID: number,
    entityType: string,
    refundeeName: string,
    transactionStatus: number,
    transactionStatusDescription: string,
    transactionDate: string,
    paymentAmount: number,
    transactionNumber: string,
    paymentTypeID: string,
    paymentMethodID: string, 
    patientID: number,
    patientName: string,
    patientRhcDate: string
};
export interface IClaimRegisterDetail {
    id: number,
    refundeeName: string,
    refundArea: string,
    claimID: number,
    refundAmount: number,
    paymentTypeDescription: string,
    createdBy: number,
    transactedBy: string,
    selected?: boolean
};
export interface IRefundRegisterResponse {
    refundDetail: IRefundRegisterDetail,
    refundContactList: IRefundContact[],
    refundAddressList: IRefundAddress[],
    claimList: IClaimRegisterDetail[]
};
export interface IClaimRegisterList {
    claimRegisterID: number,
};
export interface ITransactionCreateRequest {
    refundEntityID: number,
    paymentMethodID: number, 
    paymentTypeID: number,
    transactionNumber: string,
    transactionStatus: number,
    registerList: IClaimRegisterList[]
};
export interface ITransactionUpdateRequest {
    transactionRegisterID: number,
    transactionStatus: number,
    paymentMethodID: number, 
    paymentTypeID: number,
    transactionNumber: string,
};

// These are calls back to the .chtml screen..
export function UpdateTitleBar(transactionRegisterIdentifier: string, refundee_name: string) : void { 
    const register_function = checkWindowFunctionWithArgs<() => void>('SetRefundRegisterTitle',false);
    if (register_function) { 
        register_function (transactionRegisterIdentifier, refundee_name);
    }        

};